export const defaultSchema = {
  scenario: [{
    name: 'defaultScenario',
    value: 'Ad Library Default Scenario',
    activity: [{
      name: 'logError',
      value: 'Ad Library Custom Error',
    }, {
      name: 'logTrace',
      value: 'Ad Library Custom Trace',
    }, {
      name: 'logMetrics',
      value: 'Ad Library Metrics',
    }],
  }],
};

export const fetchEventSchema = {
  scenario: [
    {
      name: 'fetchEvent',
      value: 'Fetch Event Scenario',
      activity: [
        {
          name: 'fetchTrace',
          value: 'Fetch Event Trace',
        },
        {
          name: 'fetchError',
          value: 'Fetch Event Error',
        },
      ],
    },
  ],
};

export const globalErrorSchema = {
  scenario: [{
    name: 'appReactGlobalError',
    value: 'Log application global react error',
    activity: [{
      name: 'logError',
      value: 'Log Error Info',
    }],
  }],
};
